import React from 'react';
import { SvgIcon } from '@mui/material';
import { iconType } from './icon-types';

const Transactions = (properties: iconType) => (
  <SvgIcon
    {...properties}
    viewBox="0 0 20 20"
    style={{ fill: 'none', width: '27px', height: '37px', strokeWidth: '.07rem' }}
  >
    <path d="M11.9788 8.90337C11.9788 7.99501 11.2424 7.25864 10.3341 7.25864C9.4257 7.25864 8.68933 7.99501 8.68933 8.90337C8.68933 9.81173 9.4257 10.5481 10.3341 10.5481C11.2424 10.5481 11.9788 9.81173 11.9788 8.90337Z" />
    <path d="M7.32731 13.5547C4.75825 10.9856 4.75825 6.81789 7.32731 4.25212" />
    <path d="M4.42005 16.4626C0.24409 12.2883 0.245734 5.51864 4.42005 1.34597" />
    <path d="M13.3585 4.2334C15.9275 6.80246 15.9275 10.9702 13.3585 13.536" />
    <path d="M16.2656 1.32568C20.4416 5.5 20.4399 12.2697 16.2656 16.4424" />
  </SvgIcon>
);

export default Transactions;
